import { render } from "./chaxun.vue?vue&type=template&id=2b18170c&scoped=true"
import script from "./chaxun.vue?vue&type=script&lang=js"
export * from "./chaxun.vue?vue&type=script&lang=js"

import "./chaxun.vue?vue&type=style&index=0&id=2b18170c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b18170c"

export default script